
import React, { useState } from 'react';
import { handleLogin, showToast, Authme } from "../Utils/utils"
import Loaderspinner from '../../components/Loader';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const Loginauth = async (e) => {
    e.preventDefault();
    try {
      setLoading(true)
      let response = await handleLogin({
        email,
        password,
      });
      console.log(response, "response.....")
      localStorage.setItem("token", response.data.access_token);
      await handleAuthme();
      showToast(response.message, "success");
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, [1000])

    } catch (error) {
      console.log(error, "error...");
      setLoading(false)
      showToast(error.message, "error")
      setLoading(false)
    } finally {
      setLoading(false)
    }
  };

  const handleAuthme = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found!");
      return;
    }

    try {
      const response = await Authme(token);

      localStorage.setItem("role", response?.data?.role);

    } catch (error) {
      console.error("Authme error:", error);
    }
  };



  return (
    <>
      {loading && <Loaderspinner />}
      <section>
        <div className="page-header section-height-75">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto">
                <div className="card card-raised shadow-10 mt-5 mt-xl-5 mb-4">
                  <div className="card-header pb-0 text-center bg-transparent">
                    <img
                      className="mb-3"
                      src="/img/StrideCapitalLogo.png"
                      alt="..."
                      style={{ height: "58px" }}
                    />
                    <h5
                      className="font-weight-bolder"
                      style={{ color: "#87BFBB" }}
                    >
                      Login
                    </h5>
                    <p className="mb-0">
                      Enter your email and password to sign in
                    </p>
                  </div>
                  <div className="card-body">
                    <form role="form text-left" onSubmit={Loginauth}>
                      <label>Email</label>
                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email"
                          aria-label="Email"
                          aria-describedby="email-addon"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <label>Password</label>
                      <div className="mb-3">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Password"
                          aria-label="Password"
                          aria-describedby="password-addon"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      <div className="d-flex mt-4 justify-content-between">
                        <button
                          type="submit"
                          className="btn submit-btn text-white"
                          style={{
                            width: "100%",
                          }}
                        >
                          Sign in
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};


export default Login;
